import LisaSimpson from '../assets/LisaSimpson.png'
import WilliamMacDougal from '../assets/GroundskeeperWillie.png'
import MoeSzyslak from '../assets/MoeSzyslak.png'
import RalphWiggum from '../assets/RalphWiggum.png'
import Quimby from '../assets/Quimby.png'
import NickRiviera from '../assets/NickRiviera.png'
import Seymour from '../assets/Seymour.png'
import BartSimpson from '../assets/BartSimpson.png'
import MilhouseVanHouten from '../assets/MilhouseVanHouten.png'
import Duffman from '../assets/Duffman.png'
import WaylonSmithers from '../assets/WaylonSmithers.png'
import AbrahamSimpson from '../assets/AbrahamSimpson.png'
import RainierWolfcastle from '../assets/RainierWolfcastle.png'
import HomerSimpson from '../assets/HomerSimpson.png'
import OttoMann from '../assets/OttoMann.png'
import ChiefWiggum from '../assets/ChiefWiggum.png'
import MargeSimpson from '../assets/MargeSimpson.png'
import ComicBookGuy from '../assets/ComicBookGuy.png'
import FrankGrimes from '../assets/FrankGrimes.png'
import TroyMcClure from '../assets/TroyMcClure.png'

const data = [
{
    "id": 0,
    "name": "Lisa Simpson",
    "image": LisaSimpson
},
{
    "id": 1,
    "name": "Dr. William MacDougal",
    "image": WilliamMacDougal
},
{
    "id": 2,
    "name": "Moe Szyslak",
    "image": MoeSzyslak
},
{
    "id": 3,
    "name": "Ralph Wiggum",
    "image": RalphWiggum
},
{
    "id": 4,
    "name": "Joe Quimby",
    "image": Quimby
},
{
    "id": 5,
    "name": "Dr. Nick Riveira",
    "image": NickRiviera
},
{
    "id": 6,
    "name": "Seymour",
    "image": Seymour
},
{
    "id": 7,
    "name": "Bart Simpson",
    "image": BartSimpson
},
{
    "id": 8,
    "name": "Milhouse Van Houten",
    "image": MilhouseVanHouten
},
{
    "id": 9,
    "name": "Duffman",
    "image": Duffman
},
{
    "id": 10,
    "name": "Waylon Smithers",
    "image": WaylonSmithers
},
{
    "id": 11,
    "name": "Abraham Simpson",
    "image": AbrahamSimpson
},
{
    "id": 12,
    "name": "Rainier Wolfcastle",
    "image": RainierWolfcastle
},
{
    "id": 13,
    "name": "Homer Simpson",
    "image": HomerSimpson
},
{
    "id": 14,
    "name": "Otto Mann",
    "image": OttoMann
},
{
    "id": 15,
    "name": "Clancy Wiggum",
    "image": ChiefWiggum
},
{
    "id": 16,
    "name": "Marge Simpson",
    "image": MargeSimpson
},
{
    "id": 17,
    "name": "Comic Book Guy",
    "image": ComicBookGuy
},
{
    "id": 18,
    "name": "Frank Grimes",
    "image": FrankGrimes
},
{
    "id": 19,
    "name": "Troy McClure",
    "image": TroyMcClure
}
]

export default data;